import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=2810bc98&scoped=true"
import script from "./AddShipment.vue?vue&type=script&lang=js"
export * from "./AddShipment.vue?vue&type=script&lang=js"
import style0 from "./AddShipment.vue?vue&type=style&index=0&id=2810bc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810bc98",
  null
  
)

export default component.exports